module.exports = "/subscriptions/assets/ea15f759cc74ccc0eb7d354e73967685.png";